import { render } from "./TabExamLabAndOccup.vue?vue&type=template&id=444bc64e"
import script from "./TabExamLabAndOccup.vue?vue&type=script&lang=js"
export * from "./TabExamLabAndOccup.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__